import { getLocale } from "../runtime";

const sv_shortdated = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Kort datum`
};

const shortdated = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_shortdated(inputs)
	return "shortDated";
};

export { shortdated as "shortDated" };